import { render } from "./A105050.vue?vue&type=template&id=5ae98ba8&scoped=true"
import script from "./A105050.vue?vue&type=script&lang=js"
export * from "./A105050.vue?vue&type=script&lang=js"

import "./A105050.vue?vue&type=style&index=0&id=5ae98ba8&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ae98ba8"]])

export default __exports__